module.exports = __webpack_public_path__ + "img/bookbackground.6b2a72bd.png";